import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "BaseFlexTable column no-wrap scroll hide-scrollbar" }
const _hoisted_2 = ["draggable", "onMouseenter", "onDragover", "onDragstart"]
const _hoisted_3 = { class: "BaseFlexTable__primary-row row no-wrap items-center gap-sm" }
const _hoisted_4 = {
  key: 0,
  class: "LandingListTable__draggable-td"
}
const _hoisted_5 = {
  key: 1,
  class: "fs-15px text-cool-gray-80"
}

import { ITableColumn, ITableRow } from 'src/common/interfaces'
import { onMounted, onUnmounted, ref } from 'vue'

interface IProps {
  columns: ITableColumn[]
  rows: ITableRow[]
  draggable?: boolean
  headerClass?: string
  rowClass?: string
}

interface IEmits {
  (event: 'row-dragstart', row: ITableRow): void
  (event: 'row-dragover', row: ITableRow): void
  (event: 'row-dragend'): void
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseFlexTable' },
  __name: 'BaseFlexTable',
  props: {
    columns: {},
    rows: {},
    draggable: { type: Boolean, default: false },
    headerClass: { default: 'q-px-sm' },
    rowClass: { default: 'q-px-sm' }
  },
  emits: ["row-dragstart", "row-dragover", "row-dragend"],
  setup(__props: any) {





const hoveredRow = ref<ITableRow>({})
const flexTableHeaderRef = ref<HTMLElement | null>(null)
const headerWidth = ref(0)

let resizeObserver: ResizeObserver | null = null

onMounted(() => {
  if (!flexTableHeaderRef.value) return

  resizeObserver = new ResizeObserver((entries) => {
    const entry = entries[0]
    headerWidth.value = entry.contentRect.width
  })

  resizeObserver.observe(flexTableHeaderRef.value)
})

onUnmounted(() => {
  resizeObserver?.disconnect()
})

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_KIcon = _resolveComponent("KIcon")!
  const _component_k_divider = _resolveComponent("k-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "flexTableHeaderRef",
      ref: flexTableHeaderRef,
      class: _normalizeClass(["BaseFlexTable__header row no-wrap items-center", [__props.headerClass]])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (col, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["BaseFlexTable__header-cell q-py-sm", [col.cellClasses, col.headerClasses]])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["BaseFlexTable__header-cell-wrapper row no-wrap items-center", { 'q-pr-sm': col.separator === false }])
          }, [
            _createElementVNode("span", {
              class: "fs-13px fw-500 text-cool-gray-100 q-px-xs flex-1",
              style: _normalizeStyle(col.style)
            }, _toDisplayString(col.label), 5),
            ((col.separator === undefined || col.separator === true) && index < __props.columns.length - 1)
              ? (_openBlock(), _createBlock(_component_q_separator, {
                  key: 0,
                  vertical: "",
                  color: "cool-gray-30",
                  class: "q-mx-xs"
                }))
              : _createCommentVNode("", true)
          ], 2)
        ], 2))
      }), 128))
    ], 2),
    _createElementVNode("div", {
      class: "BaseFlexTable__body q-pt-12",
      style: _normalizeStyle(`min-width: ${headerWidth.value}px;`)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (row, rowIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          key: rowIndex,
          class: "BaseFlexTable__row column no-wrap",
          draggable: __props.draggable,
          onMouseenter: ($event: any) => (hoveredRow.value = row),
          onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (hoveredRow.value = {})),
          onDragover: ($event: any) => (__props.draggable && _ctx.$emit('row-dragover', row)),
          onDragstart: ($event: any) => (__props.draggable && _ctx.$emit('row-dragstart', row)),
          onDragend: _cache[1] || (_cache[1] = ($event: any) => (__props.draggable && _ctx.$emit('row-dragend')))
        }, [
          _renderSlot(_ctx.$slots, "row", {
            row: row,
            rowIndex: rowIndex
          }, () => [
            _createElementVNode("div", {
              class: _normalizeClass(["column no-wrap", [__props.rowClass]])
            }, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (col, colIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: colIndex,
                    class: _normalizeClass([col.cellClasses, col.rowClasses]),
                    style: _normalizeStyle(col.style)
                  }, [
                    _renderSlot(_ctx.$slots, col.slot, {
                      row: row,
                      rowIndex: rowIndex,
                      col: col
                    }, () => [
                      (col.draggable)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                            _withDirectives(_createElementVNode("span", {
                              class: _normalizeClass(["fs-15px fw-400", [
                        {
                          'text-cool-gray-60': !(row.is_active ?? true),
                          'q-pl-xs': __props.draggable,
                        },
                      ]])
                            }, _toDisplayString(rowIndex + 1), 3), [
                              [_vShow, !__props.draggable || hoveredRow.value.id !== row.id]
                            ]),
                            _withDirectives(_createVNode(_component_KIcon, {
                              name: "arrangement",
                              size: "24px",
                              color: "cool-gray-60",
                              class: "cursor-grab"
                            }, null, 512), [
                              [_vShow, __props.draggable && hoveredRow.value.id === row.id]
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(row[String(col.field)]), 1))
                    ])
                  ], 6))
                }), 128))
              ]),
              _renderSlot(_ctx.$slots, "supplementary-row", {
                row: row,
                rowIndex: rowIndex
              })
            ], 2)
          ]),
          (rowIndex < __props.rows.length - 1)
            ? (_openBlock(), _createBlock(_component_k_divider, {
                key: 0,
                dotted: true,
                color: "cool-gray-50",
                class: "q-my-12"
              }))
            : _createCommentVNode("", true)
        ], 40, _hoisted_2))
      }), 128))
    ], 4)
  ]))
}
}

})